import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalHeader } from 'reactstrap';
import { ModalBody } from 'react-bootstrap';
import { If, Else, Then } from 'react-if';
import './styles.css';
import Post from '../Post';
import { usePost } from '../../usePost';
import PostLoader from '../../../../components/elements/loader/PostLoader';

const PostModal = ({ isOpen, postId, onToggle }) => {
    const { post, isLoading } = usePost(postId);

    const emptyHandler = useCallback(() => {}, []);

    const handleRefresh = useCallback(() => {
        onToggle();
    }, [onToggle]);

    return (
        <Modal isOpen={isOpen} toggle={onToggle} className="post-preview-modal">
            <ModalHeader toggle={onToggle} />
            <ModalBody>
                <If condition={isLoading}>
                    <Then>
                        <PostLoader />
                    </Then>
                    <Else>
                        {() => (
                            <Post
                                measure={isLoading}
                                index={0}
                                style={{}}
                                id={post.uid}
                                title={post.title}
                                media={post.media}
                                description={post.description}
                                categoryId={post.category}
                                createdTimestamp={post.createdTimestamp}
                                firstName={post.user.firstName}
                                lastName={post.user.lastName}
                                totalDonations={post.totalDonations}
                                questionType={post.question.type}
                                rawPost={post}
                                questions={post.question.questions}
                                publisherUid={post.publisherUid}
                                isApprovedByAdmin={post.isApprovedByAdmin}
                                onReviewsOpen={emptyHandler}
                                isPostPopup={true}
                                approvedMode={false}
                                onRefresh={handleRefresh}
                                onReviewButtonClick={emptyHandler}
                            />
                        )}
                    </Else>
                </If>
            </ModalBody>
        </Modal>
    );
};

PostModal.propTypes = {
    postId: PropTypes.string.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onToggle: PropTypes.func.isRequired,
};

export default React.memo(PostModal);
